export default {
  state: {
    clickSoundIndex: 0,
    clickSounds: [
      new Audio('/assets/sounds/click1.mp3'),
      new Audio('/assets/sounds/click2.mp3'),
      new Audio('/assets/sounds/click3.mp3'),
      new Audio('/assets/sounds/click4.mp3'),
      new Audio('/assets/sounds/click5.mp3'),
      new Audio('/assets/sounds/click6.mp3'),
      new Audio('/assets/sounds/click7.mp3'),
      new Audio('/assets/sounds/click8.mp3'),
    ]
  },

  actions: {
    playClickSound({ state }) {
      return
      if (state.clickSoundIndex >= state.clickSounds.length) {
        state.clickSoundIndex = 0
      }
      state.clickSounds[state.clickSoundIndex++].play()
    }
  }
}